// 百科：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 个人百科
export const personal = Object.freeze({
  "myWiki.center": "百科中心",
  "myWiki.all": "全部",
  "myWiki.viewLibrary": "查看百科庫",
  "myWiki.publish": "發佈百科",
  "myWiki.mine.title": "我的發佈",
  "myWiki.mine.description": "查看當前賬號發佈或維護過的百科記錄。",
  "myWiki.mine.search": "搜索我的發佈",
  "myWiki.mine.entry": "詞條名稱",
  "myWiki.mine.definition": "詞條釋義",
  "myWiki.mine.source": "來源",
  "myWiki.mine.status": "狀態",
  "myWiki.mine.reviewFeedback": "審核意見",
  "myWiki.mine.publishedAt": "發佈時間",
  "myWiki.mine.actions": "操作",
  "myWiki.mine.view": "查看",
  "myWiki.mine.noDefinition": "暫無詞條釋義",
  "myWiki.mine.empty": "暫無當前賬號發佈記錄",
  "myWiki.mine.contributed": "參與修改",
  "myWiki.mine.userSource": "用戶發佈",
  "myWiki.mine.internalSource": "內部發布",
  "myWiki.status.reviewing": "待審核",
  "myWiki.status.pending_review": "智能審核中",
  "myWiki.status.ai_correction_pending": "待確認",
  "myWiki.status.revision_required": "需修改",
  "myWiki.status.manual_review": "人工複核",
  "myWiki.status.published": "已發佈",
  "myWiki.status.offline": "已下架",
  "myWiki.status.scheduled": "計劃發佈",
  "myWiki.status.rejected": "審核不通過",
  "myWiki.status.draft": "草稿",
  "myWiki.collection.title": "我的收藏",
  "myWiki.collection.summary": "收藏統計",
  "myWiki.collection.saved": "收藏",
  "myWiki.collection.current": "當前",
  "myWiki.collection.brands": "品牌",
  "myWiki.collection.description":
    "集中管理已收藏的晶片百科型號，快速查看詳情和資料完整度。",
  "myWiki.collection.searchPlaceholder": "搜索型號、品牌、分類",
  "myWiki.collection.noSummary": "暫無簡介",
  "myWiki.collection.completeness": "資料完整度",
  "myWiki.collection.viewDetail": "查看詳情",
  "myWiki.collection.removeFavorite": "取消收藏",
  "myWiki.collection.empty": "暫無收藏內容",
  "myWiki.collection.removed": "已取消收藏",
  "myWiki.collection.removeFailed": "取消收藏失敗，請稍後重試",
  "myWiki.questions.title": "我的問答",
  "myWiki.questions.description": "查看你在晶片百科中提出的問題、回答和評論。",
  "myWiki.questions.enterCommunity": "進入百科問答",
  "myWiki.questions.questions": "我的提問",
  "myWiki.questions.answers": "我的回答",
  "myWiki.questions.comments": "我的評論",
  "myWiki.questions.loginPrompt": "登入後查看你的問答記錄。",
  "myWiki.questions.loginNow": "立即登入",
  "myWiki.questions.loading": "正在載入…",
  "myWiki.questions.retry": "重試",
  "myWiki.questions.loginAgain": "重新登入",
  "myWiki.questions.attachmentAnswer": "附件回答",
  "myWiki.questions.noDescription": "未補充説明",
  "myWiki.questions.answerCount": "{count} 個回答",
  "myWiki.questions.answered": "回答了該問題",
  "myWiki.questions.commented": "參與了該問題的討論",
  "myWiki.questions.delete": "刪除",
  "myWiki.questions.deleted": "已刪除",
  "myWiki.questions.viewDiscussion": "查看討論",
  "myWiki.questions.empty.questions": "暫未發佈問題",
  "myWiki.questions.empty.answers": "暫未發佈回答",
  "myWiki.questions.empty.comments": "暫未發佈評論",
  "myWiki.questions.loginExpired": "登入已失效，請重新登入。",
  "myWiki.questions.loadFailed": "問答記錄載入失敗，請稍後重試。",
  "myWiki.questions.deleteSuccess": "已刪除",
  "myWiki.questions.deleteOwnOnly": "只能刪除自己的內容。",
  "myWiki.questions.deleteUnavailable":
    "刪除介面尚未啓用或該內容已不可用，未刪除。",
  "myWiki.questions.deleteFailed": "刪除失敗，請稍後重試。",
});

// 百科受控显示
export const display = Object.freeze({
  "wikiDisplay.category.memory": "儲存器",
  "wikiDisplay.category.flash": "快閃記憶體",
  "wikiDisplay.category.nand": "NAND 快閃記憶體",
  "wikiDisplay.category.nor": "NOR 快閃記憶體",
  "wikiDisplay.category.ssd": "固態硬碟",
  "wikiDisplay.category.chip": "晶片",
  "wikiDisplay.category.wiki": "百科",
  "wikiDisplay.category.mcu": "微控制器",
  "wikiDisplay.category.power": "電源管理晶片",
  "wikiDisplay.category.interface": "介面晶片",
  "wikiDisplay.category.sensor": "感應器",
  "wikiDisplay.parameter.capacity": "容量",
  "wikiDisplay.parameter.density": "儲存密度",
  "wikiDisplay.parameter.accessTime": "存取時間",
  "wikiDisplay.parameter.package": "封裝",
  "wikiDisplay.parameter.voltage": "電壓",
  "wikiDisplay.parameter.operatingVoltage": "工作電壓",
  "wikiDisplay.parameter.supplyVoltage": "供電電壓",
  "wikiDisplay.parameter.speed": "速率",
  "wikiDisplay.parameter.frequency": "頻率",
  "wikiDisplay.parameter.temperature": "工作溫度",
  "wikiDisplay.parameter.interface": "介面",
  "wikiDisplay.parameter.width": "位寬",
  "wikiDisplay.parameter.organization": "組織",
  "wikiDisplay.parameter.pins": "引腳數",
  "wikiDisplay.parameter.process": "製程",
  "wikiDisplay.parameter.power": "功耗",
  "wikiDisplay.parameter.brand": "品牌／廠商",
  "wikiDisplay.parameter.manufacturer": "製造商",
  "wikiDisplay.parameter.category": "所屬分類",
  "wikiDisplay.parameter.model": "型號",
  "wikiDisplay.parameter.period": "供貨狀態",
  "wikiDisplay.parameter.description": "內容描述",
  "wikiDisplay.parameter.base": "基本資料",
  "wikiDisplay.parameter.spec": "核心規格",
  "wikiDisplay.parameter.packaging": "封裝資料",
  "wikiDisplay.parameter.parameter": "參數",
  "wikiDisplay.parameter.datasheet": "規格書",
  "wikiDisplay.parameter.body": "百科正文",
  "wikiDisplay.parameter.dataRate": "資料速率",
  "wikiDisplay.parameter.productName": "產品名稱",
  "wikiDisplay.parameter.partNumber": "料號型號",
  "wikiDisplay.parameter.series": "產品系列",
  "wikiDisplay.parameter.price": "參考單價",
  "wikiDisplay.parameter.quantity": "庫存數量",
  "wikiDisplay.parameter.location": "貨物所在地",
  "wikiDisplay.parameter.batch": "批次",
  "wikiDisplay.parameter.condition": "貨物狀況",
  "wikiDisplay.parameter.application": "應用領域",
  "wikiDisplay.parameter.moq": "最低訂購量",
  "wikiDisplay.parameter.leadTime": "交貨期",
  "wikiDisplay.parameter.validity": "有效期",
  "wikiDisplay.parameter.alternative": "替代型號",
  "wikiDisplay.parameter.cas": "CAS 延遲",
  "wikiDisplay.status.draft": "草稿",
  "wikiDisplay.status.reviewing": "待審核",
  "wikiDisplay.status.processing": "審核中",
  "wikiDisplay.status.manual": "人工覆核",
  "wikiDisplay.status.confirm": "待確認",
  "wikiDisplay.status.revision": "需修改",
  "wikiDisplay.status.rejected": "審核不通過",
  "wikiDisplay.status.denied": "已拒絕",
  "wikiDisplay.status.published": "已發佈",
  "wikiDisplay.status.offline": "已下架",
  "wikiDisplay.status.scheduled": "排程發佈",
  "wikiDisplay.review.pendingPreview": "待審核版本預覽",
  "wikiDisplay.review.view": "百科詳情",
  "wikiDisplay.review.pendingVersionHint":
    "目前顯示的是用戶本次提交的修改內容，並非百科庫中的已發佈版本。",
  "wikiDisplay.review.readOnlyHint":
    "目前為查看入口，只顯示此百科條目的公開內容及發佈狀態。",
  "wikiDisplay.review.internal": "內部百科管理詳情",
  "wikiDisplay.review.processingTitle": "此百科內容正在審核",
  "wikiDisplay.review.processingHint":
    "這是你的提交預覽，內容尚未進入公開百科庫。審核通過後，其他用戶才能查看正式版本。",
  "wikiDisplay.review.aiTitle": "AI 已生成修正建議",
  "wikiDisplay.review.aiHint":
    "請核對下方修改前後對比；接受後會重新審核，未確認則轉人工覆核。",
  "wikiDisplay.review.manualTitle": "此百科內容正在人工覆核",
  "wikiDisplay.review.manualHint":
    "人工審核通過後發佈；未通過則退回至「需修改」。",
  "wikiDisplay.review.revisionTitle": "此百科內容已退回修改",
  "wikiDisplay.review.revisionHint": "請按審核意見修正後重新提交。",
  "wikiDisplay.review.rejectedTitle": "此百科內容未通過審核",
  "wikiDisplay.review.rejectedHint":
    "此版本已終止發佈，具體原因請查看下方審核意見。",
  "wikiDisplay.review.offlineTitle": "此百科內容已由管理員下架",
  "wikiDisplay.review.offlineHint":
    "此內容已停止公開顯示，具體原因請查看下方管理意見。",
  "wikiDisplay.review.draftTitle": "此百科有尚未提交的修改草稿",
  "wikiDisplay.review.draftHint":
    "目前草稿僅你本人可見；已發佈版本仍正常公開顯示。",
  "wikiDisplay.review.withdrawnTitle": "此百科投稿已撤回",
  "wikiDisplay.review.withdrawnHint":
    "目前內容僅你本人可見，不再進入審核佇列。",
  "wikiDisplay.review.publishedTitle": "此百科內容已發佈",
  "wikiDisplay.review.publishedHint":
    "這是已通過審核的公開百科詳情，用戶可從百科庫及相關產品入口查看。",
  "wikiDisplay.review.waitManual": "等待人工審核結果",
  "wikiDisplay.review.waitInternal": "等待內部確認後發佈",
  "wikiDisplay.review.allowed": "已允許進入公開百科庫",
  "wikiDisplay.review.hidden": "已停止公開顯示",
  "wikiDisplay.review.stopped": "此版本已終止發佈",
  "wikiDisplay.review.internalDraft": "內部暫存，尚未進入公開庫",
  "wikiDisplay.review.checkSubmitted":
    "目前顯示用戶本次提交的待審核版本。請核對後選擇通過或退回修改。",
  "wikiDisplay.review.checkQueue":
    "此條目來自百科審核佇列，請核對圖片、參數、詞條欄位及內容描述後確認發佈。",
  "wikiDisplay.review.checkPublished":
    "此條目已通過審核並進入百科庫，可繼續核對完整度或補充規格、圖片及商品關聯資料。",
  "wikiDisplay.review.checkOffline":
    "此詞條已下架，不會進入用戶修改佇列；如需恢復，請先轉人工覆核並重新審核。",
  "wikiDisplay.review.checkRejected":
    "此版本未通過人工審核，不能繼續進入發佈流程。",
  "wikiDisplay.review.checkDraft":
    "此條目為內部草稿，可補齊資料後轉入待審核或直接發佈。",
  "wikiDisplay.review.approve": "審核通過並發佈",
  "wikiDisplay.review.return": "退回修改",
  "wikiDisplay.review.returnMore": "退回補充",
  "wikiDisplay.review.offlinePending": "下架轉待審",
  "wikiDisplay.review.pendingAgain": "重新待審",
  "wikiDisplay.review.saveDraft": "儲存草稿",
  "wikiDisplay.review.plan": "制定審核計劃",
  "wikiDisplay.review.identify": "識別產品型號",
  "wikiDisplay.review.retrieve": "檢索規格書證據",
  "wikiDisplay.review.extract": "擷取關鍵參數",
  "wikiDisplay.review.advertising": "檢查廣告及導流",
  "wikiDisplay.review.objectivity": "檢查內容客觀性",
  "wikiDisplay.review.verify": "逐項事實核驗",
  "wikiDisplay.review.check": "審核檢查",
  "wikiDisplay.review.supported": "原文支持",
  "wikiDisplay.review.contradicted": "存在矛盾",
  "wikiDisplay.review.insufficient": "證據不足",
  "wikiDisplay.review.unverified": "待核驗",
  "wikiDisplay.parameterText": "{label}：{value}",
  "wikiDisplay.favorite.added": "已加入收藏",
  "wikiDisplay.favorite.removed": "已取消收藏",
  "wikiDisplay.error.AUTH_REQUIRED": "請先登入再操作",
  "wikiDisplay.error.FORBIDDEN": "目前賬號沒有此操作權限",
  "wikiDisplay.error.NOT_FOUND": "找不到對應的百科內容",
  "wikiDisplay.error.INVALID_ARGUMENT":
    "提交內容不完整或參數無效，請檢查後重試",
  "wikiDisplay.error.RATE_LIMITED": "請求過於頻密，請稍後重試",
  "wikiDisplay.error.TIMEOUT": "百科服務回應逾時，請稍後重試",
  "wikiDisplay.error.UNAVAILABLE": "百科服務暫時無法使用，請稍後重試",
  "wikiDisplay.error.REQUEST_FAILED": "操作失敗，請稍後重試",
  "wikiDisplay.error.PUBLISH_FAILED": "提交百科內容失敗，請稍後重試",
  "wikiDisplay.error.ROW_REQUIRED": "第 {index} 項缺少必填內容",
});

// 百科页面
export const pages = Object.freeze({
  "wiki.backToEntry": "返回詞條",
  "wiki.community": "晶片百科社區",
  "wiki.questions": "問答",
  "wiki.questionsIntro":
    "圍繞型號參數、使用經驗和選型替代進行討論，幫助更多人快速找到答案。",
  "wiki.ask": "我要提問",
  "wiki.searchQuestions": "搜索問題",
  "wiki.loadingQuestions": "正在載入問答…",
  "wiki.retry": "重試",
  "wiki.awaitingAnswer": "等待回答",
  "wiki.questionMark": "問",
  "wiki.answerMark": "答",
  "wiki.answerImage": "回答附圖",
  "wiki.answerCount": "{count} 個回答",
  "wiki.answerQuestion": "回答問題",
  "wiki.writeAnswer": "寫下你的回答…",
  "wiki.pendingImage": "待發布圖片",
  "wiki.deleteImage": "刪除圖片",
  "wiki.deleteFile": "刪除檔案",
  "wiki.attachmentHelp":
    "支持 PNG/JPG/GIF/WebP 圖片及 PDF/TXT/CSV/DOCX/XLSX/PPTX 檔案；合計最多 8 個，每個不超過 10MB",
  "wiki.addImage": "添加圖片",
  "wiki.addFile": "添加檔案",
  "wiki.cancel": "取消",
  "wiki.publishAnswer": "發佈回答",
  "wiki.noQuestions": "暫未找到相關問題",
  "wiki.firstQuestion": "發佈第一個問題",
  "wiki.continueBrowsing": "繼續瀏覽",
  "wiki.similarQuestions": "類似問題",
  "wiki.similarHint": "這些問題也許能幫你更快找到答案",
  "wiki.discussionCount": "{count} 個討論",
  "wiki.hotQuestions": "熱門問答",
  "wiki.noHotQuestions": "暫時還沒有熱門討論",
  "wiki.answerInvitations": "等你來答",
  "wiki.relatedProducts": "全站相關產品提問",
  "wiki.publishQuestion": "發佈問題",
  "wiki.askHint": "清楚描述問題，更容易獲得有價值的回答",
  "wiki.discussing": "正在討論",
  "wiki.questionRules": "發佈問答規則",
  "wiki.ruleRelevant": "圍繞當前產品的參數、使用經驗和選型替代進行提問",
  "wiki.ruleNoTrade": "請勿發佈交易、聯絡方式或與產品無關的資料",
  "wiki.questionTitle": "問題標題",
  "wiki.titleHint": "一句話説明你想了解的內容",
  "wiki.titleExample": "例如：該型號可以直接替代同系列產品嗎？",
  "wiki.details": "補充説明",
  "wiki.detailsHint": "可補充使用場景、已確認參數或遇到的現象",
  "wiki.detailsPlaceholder":
    "提供更多背景資料，可以幫助大家更準確地回答你的問題…",
  "wiki.productFallback": "該產品",
  "wiki.allQuestions": "全部問答",
  "wiki.communityQuestions": "社區問答",
  "wiki.wikiUser": "百科用戶",
  "wiki.communityUser": "社區用戶",
  "wiki.loginFirst": "請先登入",
  "wiki.operationFailed": "操作失敗，請稍後重試，草稿已保留",
  "wiki.loadFailed": "問答載入失敗，請確認產品鏈接後重試。",
  "wiki.fileInvalid": "{name} 的格式或大小不符合要求",
  "wiki.fileLimit": "圖片和檔案合計最多 8 個",
  "wiki.enterFromProduct": "請從產品百科進入問答後提問",
  "wiki.questionPublished": "問題已發佈",
  "wiki.answerPublished": "回答已發佈",
  "wiki.heroTitle": "晶片百科，讓知識觸手可及",
  "wiki.searchPlaceholder": "搜索型號、品牌、分類",
  "wiki.categoryLabel": "晶片分類：",
  "wiki.productCount": "{count} 個產品",
  "wiki.collapse": "收起",
  "wiki.expand": "展開",
  "wiki.brandLabel": "品牌：",
  "wiki.brandInitials": "按品牌首字母篩選",
  "wiki.brandFilter": "品牌篩選",
  "wiki.all": "全部",
  "wiki.publishEntry": "發佈詞條",
  "wiki.noDescription": "暫無描述",
  "wiki.unfavorite": "取消收藏",
  "wiki.favorite": "收藏",
  "wiki.loadingMore": "正在載入…",
  "wiki.loadMoreProducts": "載入更多產品",
  "wiki.noProducts": "暫無相關產品資料",
  "wiki.publishEntryTitle": "發佈百科詞條",
  "wiki.publishEntryHint": "提交後進入百科審核，審核通過後展示到公開百科庫。",
  "wiki.entryName": "詞條名稱",
  "wiki.entryNamePlaceholder": "請輸入百科詞條名稱",
  "wiki.entryDefinition": "詞條釋義",
  "wiki.entryDefinitionPlaceholder":
    "請説明該百科內容是什麼、用於什麼場景、有哪些關鍵特徵",
  "wiki.entryBody": "百科正文",
  "wiki.entryBodyPlaceholder": "請補充背景、用途、參數含義或選型説明",
  "wiki.publishReason": "發佈説明",
  "wiki.publishReasonPlaceholder": "例如：新增型號百科、補充資料來源",
  "wiki.datasheetOptional": "規格書（選填）",
  "wiki.choosePdf": "選擇 PDF 規格書",
  "wiki.pdfHelp": "僅支持 PDF，最大 50MB；不上傳也可以正常發佈。",
  "wiki.publishMode": "發佈方式",
  "wiki.immediate": "立即發佈",
  "wiki.scheduled": "計劃發佈",
  "wiki.scheduledAt": "計劃發佈時間",
  "wiki.chooseFutureTime": "選擇未來的發佈時間",
  "wiki.scheduleHelp":
    "提交後先進入百科審核；只有審核通過，才會在計劃時間發佈到公開百科。",
  "wiki.manageSchedule": "管理已儲存的計劃發佈",
  "wiki.saveSchedule": "儲存計劃",
  "wiki.submitReview": "提交審核",
  "wiki.scheduleManager": "計劃發佈管理",
  "wiki.noScheduled": "暫無待發布的百科內容",
  "wiki.scheduledTime": "計劃發佈時間：",
  "wiki.changeTime": "修改時間",
  "wiki.publishNow": "立即發佈",
  "wiki.cancelSchedule": "取消計劃",
  "wiki.reviewProcess": "智能體審核過程",
  "wiki.checked": "已完成檢查",
  "wiki.failed": "失敗",
  "wiki.complete": "完成",
  "wiki.factCheck": "逐項事實核驗",
  "wiki.factClaim": "事實聲明",
  "wiki.datasheetPage": "規格書第 {page} 頁",
  "wiki.noPage": "暫無可定位的原文頁碼",
  "wiki.reviseHint": "請根據{opinion}修改詞條，完成後重新提交審核。",
  "wiki.reviseByOpinion": "按照意見修改",
  "wiki.withdrawHint": "如果不想繼續本次發佈，可以撤回投稿並保留為草稿。",
  "wiki.withdraw": "撤回投稿",
  "wiki.withdrawnHint":
    "投稿已撤回，不再進入審核隊列。你可以繼續編輯或刪除草稿。",
  "wiki.continueEdit": "繼續編輯",
  "wiki.deleteDraft": "刪除草稿",
  "wiki.manualReviewOpinion": "人工複核意見（退回修改或審核不通過時填寫）",
  "wiki.manualReviewPlaceholder":
    "請明確填寫需要用戶修改的內容和原因，提交後用戶可在審核意見中查看",
  "wiki.manualReviewRequired":
    "審核通過無需填寫；退回修改或審核不通過時意見不能為空",
  "wiki.approvePublish": "審核通過併發布",
  "wiki.returnForRevision": "確認退回修改",
  "wiki.rejectReview": "審核不通過",
  "wiki.reviewManagement": "審核發佈管理",
  "wiki.reviewManagementHint": "管理該百科條目是否允許進入公開百科庫",
  "wiki.currentStatus": "當前狀態",
  "wiki.completeness": "資料完整度",
  "wiki.readyToPublish": "滿足發佈檢查",
  "wiki.completeBeforePublish": "建議補齊後再發布",
  "wiki.publishCheck": "發佈檢查",
  "wiki.present": "已齊",
  "wiki.missing": "待補",
  "wiki.missingFields": "待補字段：",
  "wiki.allProducts": "全部產品",
  "wiki.otherInitial": "其他",
  "wiki.batchReview": "批量提交百科審核",
  "wiki.batchReviewHint":
    "每條內容都會獨立進入智能審核；只有審核通過後，才會展示到公開百科庫。",
  "wiki.uploadExtract": "上傳檔案自動提取百科內容",
  "wiki.batchImportHelp":
    "支持 xlsx、xls、csv、json、txt。表格表頭可用：詞條名稱、詞條釋義、百科正文、發佈説明、品牌、分類。",
  "wiki.parsedFile": "已解析：",
  "wiki.batchSize": "每批條數",
  "wiki.itemsUnit": "條",
  "wiki.submitInterval": "提交間隔",
  "wiki.secondsUnit": "秒",
  "wiki.batchDefaultHint":
    "預設每 5 秒提交 10 條，每條都會調用後端正式審核介面，不會直接發佈。",
  "wiki.submittingEach": "正在逐條提交審核",
  "wiki.batchCancelled": "已取消分批提交",
  "wiki.submitProgress": "審核提交進度",
  "wiki.batchNext": "本批完成後，{seconds} 秒後繼續提交下一批。",
  "wiki.batchRemaining": "剩餘 {count} 條尚未提交，可修改後重新開始。",
  "wiki.batchFailed": "{count} 條提交失敗，已保留在列表中，可稍後重試。",
  "wiki.totalItems": "共 {count} 條",
  "wiki.addOne": "添加一條",
  "wiki.entryNumber": "百科詞條 {number}",
  "wiki.entryNameMissing": "未填寫詞條名稱",
  "wiki.fillFromFile": "從檔案填充本條",
  "wiki.delete": "刪除",
  "wiki.brand": "品牌",
  "wiki.category": "分類",
  "wiki.extractFromFile": "可由檔案自動提取",
  "wiki.addEntry": "添加一條百科",
  "wiki.cancelSubmit": "取消提交",
  "wiki.submittingReview": "正在提交審核",
  "wiki.continueSubmit": "繼續提交審核",
  "wiki.startBatchSubmit": "開始分批提交審核",
  "wiki.entryKicker": "晶片百科詞條",
  "wiki.copyEntryName": "複製詞條名稱",
  "wiki.edit": "修改",
  "wiki.favorited": "已收藏",
  "wiki.entryDefinitionPlaceholderShort": "請輸入詞條釋義",
  "wiki.introLoading": "正在載入產品簡介…",
  "wiki.noIntro": "該產品暫無簡介內容",
  "wiki.contents": "目錄",
  "wiki.basicInfo": "基本資料",
  "wiki.datasheetResults": "規格書 PDF 與解析結果",
  "wiki.fullscreen": "全屏瀏覽",
  "wiki.downloadDatasheet": "規格書下載",
  "wiki.datasheet": "規格書",
  "wiki.exitFullscreen": "退出全屏瀏覽",
  "wiki.noDatasheet": "該產品暫未關聯規格書 PDF",
  "wiki.datasheetLabel": "規格書：",
  "wiki.noFilename": "暫無檔案名稱",
  "wiki.parsingStatus": "解析狀態：",
  "wiki.datasheetCharts": "規格書相關圖表",
  "wiki.specification": "規格説明",
  "wiki.technicalFeatures": "技術特點",
  "wiki.summaryLoading": "正在檢索規格書並生成説明…",
  "wiki.applications": "應用領域",
  "wiki.usageNotes": "使用注意事項",
  "wiki.backToCommunity": "返回知道首頁",
  "wiki.recommendedTopics": "推薦專題",
  "wiki.topicIntroduction": "專題導讀",
  "wiki.engineeringGuide": "工程實踐指南",
  "wiki.backToOverview": "返回概覽",
  "wiki.featuredQnA": "精選問答",
  "wiki.questionCount": "{count} 個問題",
  "wiki.topicContents": "專題內容",
  "wiki.ordinal1": "一",
  "wiki.ordinal2": "二",
  "wiki.ordinal3": "三",
  "wiki.ordinal4": "四",
  "wiki.ordinal5": "五",
  "wiki.ordinal6": "六",
  "wiki.ordinal7": "七",
  "wiki.backToCommunityShort": "返回知道",
  "wiki.userQnA": "用戶問答",
  "wiki.experienceSharing": "技術交流 · 經驗共享",
  "wiki.experienceIntro": "讓真實經驗與可靠依據，在這裏相遇。",
  "wiki.revalidateLogin": "重新驗證登入",
  "wiki.currentLocation": "當前位置",
  "wiki.allQuestionsShort": "全部問題",
  "wiki.questionDetails": "問題詳情",
  "wiki.communityDiscussion": "社區討論",
  "wiki.hasAcceptedAnswer": "已有采納回答",
  "wiki.allAnswers": "全部回答",
  "wiki.experienceValued": "每一種經驗，都值得被看見",
  "wiki.noAnswersYet": "還沒有回答，歡迎分享你的經驗。",
  "wiki.aiReference": "AI 參考",
  "wiki.basedOnEncyclopedia": "基於百科資料",
  "wiki.sharedExperience": "分享實際經驗",
  "wiki.accepted": "已採納",
  "wiki.unlike": "取消點贊",
  "wiki.helpful": "有幫助",
  "wiki.unaccept": "取消採納",
  "wiki.acceptAnswer": "採納回答",
  "wiki.yourAnswer": "自己的回答",
  "wiki.comments": "評論",
  "wiki.loadingComments": "正在載入評論…",
  "wiki.noComments": "還沒有評論。",
  "wiki.writeComment": "寫下你的評論",
  "wiki.postComment": "發佈評論",
  "wiki.shareInsight": "分享你的見解",
  "wiki.replyHint": "寫下實際經驗，也歡迎附上規格書或測試依據。",
  "wiki.writeAnswerWithEvidence": "寫下你的回答和依據",
  "wiki.addAttachment": "添加圖片或文檔",
  "wiki.attachmentLimit": "最多 8 個，每個不超過 10MB",
  "wiki.uploading": "上傳中…",
  "wiki.remove": "移除",
  "wiki.questionCountTogether": "{count} 個問題 · 一起尋找答案",
  "wiki.searchUserQuestions": "搜索用戶問題",
  "wiki.search": "搜索",
  "wiki.noQuestionsPostFirst": "暫無相關問題，歡迎發佈第一個問題。",
  "wiki.backToQnA": "返回問答",
  "wiki.technicalQnADetails": "技術問答詳情",
  "wiki.questionProductIntro":
    "圍繞 {product} 的參數、選型和實際應用經驗進行討論，歡迎分享規格書依據或實際項目經驗。",
  "wiki.moreExperienceWelcome": "個回答，更多經驗等你補充",
  "wiki.letMeAnswer": "我來回答",
  "wiki.helpEngineers": "分享經驗，幫助更多工程師",
  "wiki.encyclopediaCommunity": "百科知識 · 社區交流",
  "wiki.communityExperience": "來自社區的經驗",
  "wiki.sortByTime": "按時間排序",
  "wiki.loadingAnswers": "正在載入回答…",
  "wiki.aiReferenceAnswer": "AI 參考回答",
  "wiki.encyclopediaContent": "百科內容",
  "wiki.experienceShared": "經驗分享",
  "wiki.viewAnswerEvidence": "查看回答依據",
  "wiki.viewProductEntry": "查看產品百科",
  "wiki.hideComments": "收起評論",
  "wiki.deleting": "刪除中…",
  "wiki.deleteAnswer": "刪除回答",
  "wiki.continueDiscussion": "圍繞這條回答繼續交流",
  "wiki.noCommentsInvite": "還沒有評論，來分享你的看法或補充問題吧。",
  "wiki.commentOnAnswer": "評論 {author} 的回答",
  "wiki.commentPlaceholder": "針對這條回答，説説你的看法…",
  "wiki.commentSavedNotice": "評論將儲存到社區",
  "wiki.answerDetailPlaceholder": "分享你的規格書依據、測試結果或實際使用經驗…",
  "wiki.deleteNamedImage": "刪除圖片 {name}",
  "wiki.deleteNamedFile": "刪除檔案 {name}",
  "wiki.attachmentSavedHelp":
    "支持 PNG/JPG/GIF/WebP 圖片及 PDF/TXT/CSV/DOCX/XLSX/PPTX 檔案，合計最多 8 個，每個不超過 10MB。附件隨回答儲存。",
  "wiki.relatedSearches": "相關搜索",
  "wiki.othersSearch": "大家還在搜",
  "wiki.generatingRelated": "正在生成相關搜索…",
  "wiki.regenerate": "重新生成",
  "wiki.makeExperienceVisible": "讓經驗被更多人看見",
  "wiki.yourExperienceAnswer": "你的實踐，可能正是他人的答案。",
  "wiki.shareEvidence": "分享規格書依據、測試結果或項目中積累的使用經驗。",
  "wiki.joinAnswering": "參與回答",
  "wiki.noPendingAnswers": "暫時沒有等待用戶回答的問題",
  "wiki.communityMark": "知",
  "wiki.chipQnA": "晶片知道",
  "wiki.technicalCommunity": "技術問答社區",
  "wiki.communitySearchPlaceholder": "搜索型號、封裝、參數或技術問題",
  "wiki.searchAnswers": "搜索答案",
  "wiki.xsouQnA": "XSOU 知道",
  "wiki.reliableAnswers": "讓每個技術問題，都有可靠的回答",
  "wiki.communityIntro":
    "圍繞晶片型號、規格參數、封裝兼容和實際應用經驗展開討論。",
  "wiki.technicalQuestions": "技術問題",
  "wiki.professionalAnswers": "專業回答",
  "wiki.popularChipTypes": "常搜晶片類型",
  "wiki.semiconductorBasics": "半導體基礎知識",
  "wiki.hotDiscussions": "熱門討論",
  "wiki.everyoneAsks": "大家都在問",
  "wiki.viewAll": "查看全部",
  "wiki.searchProductForAi": "搜索具體產品型號，獲取基於百科內容生成的 AI 問答",
  "wiki.chipImage": "{product} 晶片",
  "wiki.communityContribution": "社區貢獻",
  "wiki.influenceRanking": "影響力排行",
  "wiki.loadingCommunityRecords": "正在讀取社區記錄",
  "wiki.aiRolesDisclaimer":
    "暫無真人問答，以下展示 AI 角色，不代表真人貢獻排名",
  "wiki.weeklyRankingNote": "按本週發言量與回答獲贊數展示",
  "wiki.weeklyActive": "本週活躍答主",
  "wiki.roleDisplay": "角色展示",
  "wiki.weeklyPosts": "本週發言",
  "wiki.qualityContributors": "優質回答貢獻者",
  "wiki.contributionSummary":
    "{answers} 個回答 · {comments} 個評論 · {likes} 次有幫助",
  "wiki.likesReceived": "獲贊數",
  "wiki.awaitingProfessionalAnswer": "這些問題正在等待專業回答",
  "wiki.reload": "重新載入",
  "wiki.searchingQnA": "正在搜索相關問答…",
  "wiki.searchIncomplete": "搜索暫時未完成",
  "wiki.searchResultCount": "共搜索到 {count} 條結果",
  "wiki.findingQnA": "正在查找相關問答",
  "wiki.matchingKnowledge": "正在匹配已發佈的產品知識，請稍候…",
  "wiki.loadQuestionsFailed": "問答暫時載入失敗",
  "wiki.retrySearchHint": "請稍後重試，我們會重新獲取搜索結果。",
  "wiki.noRelatedQnA": "暫未找到相關問答",
  "wiki.noMatchFor": "未找到與“{keyword}”匹配的已發佈問答",
  "wiki.noPublishedQnA": "目前還沒有可展示的已發佈問答",
  "wiki.tryFullModel":
    "試試完整產品型號，或減少關鍵詞；也可以檢查型號中的字母、數字是否正確。",
  "wiki.hotSearches": "熱門搜索",
  "wiki.noRealSearches": "暫無真實搜索記錄",
  "wiki.communityRuleRelevant":
    "圍繞晶片型號、規格參數、使用經驗和選型替代進行提問。",
  "wiki.communityRuleNoTrade": "請勿發佈交易、聯絡方式或與晶片無關的資料。",
  "wiki.communityTitleExample": "例如：IS62WV51216 的封裝兼容性如何確認？",
  "wiki.communityDetailsPlaceholder":
    "可補充具體型號、使用場景、已確認參數或遇到的現象…",
  "wiki.postQuestionHint": "發佈後可在問題詳情中查看回答，與其他用戶交流。",
  "wiki.fitPage": "適配頁面",
  "wiki.rotate": "旋轉",
  "wiki.annotate": "標註",
  "wiki.undo": "撤銷",
  "wiki.redo": "重做",
  "wiki.download": "下載",
  "wiki.print": "列印",
  "wiki.more": "更多",
  "wiki.datasheetThumbnailPage": "規格書縮略圖第{page}頁",
  "wiki.productDatasheetPage": "{model} 規格書第{page}頁",
  "wiki.packageInfo": "封裝資料",
  "wiki.packageImage": "封裝圖",
  "wiki.packageType": "封裝類型",
  "wiki.pinCount": "引腳數",
  "wiki.packageSize": "封裝尺寸",
  "wiki.operatingTemperature": "工作温度",
  "wiki.relatedTerms": "相關術語",
  "wiki.references": "參考資料",
  "wiki.sameSeriesDatasheets": "同系列規格書推薦",
  "wiki.sameSeriesHint": "優先匹配產品系列和型號族，數據直接來自遠端尋知知識庫",
  "wiki.modelCount": "{count} 個型號",
  "wiki.loadingSameSeries": "正在載入同系列規格書",
  "wiki.sameSeriesFailed": "同系列規格書載入失敗",
  "wiki.indexedAt": "收錄日期",
  "wiki.noSameSeries": "暫未找到同系列規格書",
  "wiki.noSameSeriesHint":
    "遠端知識庫中暫無明確的同系列型號，可以讓 AI 助手繼續檢索相近產品。",
  "wiki.askAi": "詢問 AI 助手",
  "wiki.relatedKnowledgeProducts": "相關知識庫產品",
  "wiki.relatedProductsHint":
    "按製造商、產品分類和型號相似度推薦，不混入庫存或價格演示數據",
  "wiki.loadingRelatedProducts": "正在載入相關知識庫產品",
  "wiki.relatedProductsFailed": "相關產品載入失敗",
  "wiki.noRelatedKnowledgeProducts": "暫未找到相關知識庫產品",
  "wiki.noRelatedKnowledgeHint":
    "可以讓 AI 助手根據當前型號的參數和用途進行全庫推薦。",
  "wiki.aiRecommend": "讓 AI 推薦",
  "wiki.siteLinks": "站內相關入口",
  "wiki.siteLinksHint": "當前詞條可繼續查看站內關聯資料",
  "wiki.imageMaterials": "圖片資料",
  "wiki.uploadImage": "上傳圖片",
  "wiki.deleteCurrent": "刪除當前",
  "wiki.previousImage": "上一張",
  "wiki.nextImage": "下一張",
  "wiki.noImagesUpload": "暫無圖片資料，可上傳補充",
  "wiki.noImages": "暫無圖片資料",
  "wiki.videoMaterials": "影片資料",
  "wiki.uploadVideo": "上傳影片",
  "wiki.deleteVideo": "刪除影片",
  "wiki.videoNumber": "影片 {number}",
  "wiki.noVideosUpload": "暫無影片資料，可上傳補充",
  "wiki.videosViaEdit": "影片資料可通過修改詞條補充",
  "wiki.entryStats": "百科資料區",
  "wiki.viewsCount": "瀏覽次數：{count} 次",
  "wiki.editsCount": "編輯次數：{count} 次",
  "wiki.history": "歷史版本",
  "wiki.latestAt": "最近時間：",
  "wiki.latestEditor": "最近會員：",
  "wiki.topContributors": "突出貢獻榜",
  "wiki.contributorEdits": "{count} 次編輯",
  "wiki.relatedInfo": "相關資料",
  "wiki.relatedTags": "相關標籤",
  "wiki.detail.alreadyPublished":
    "該詞條已發佈，無需重複審核發佈；如需補充資料，可直接在詞條內容區點擊“修改”。",
  "wiki.detail.aiCorrections": "AI 修正建議",
  "wiki.detail.aiCorrectionsHint":
    "以下建議均需有資料證據支持。確認後系統會生成修正版並重新審核，不會直接發佈。",
  "wiki.detail.awaitingConfirmation": "待你確認",
  "wiki.detail.before": "修改前",
  "wiki.detail.suggested": "建議修改為",
  "wiki.detail.reason": "理由：{reason}",
  "wiki.detail.evidence": "證據：{evidence}",
  "wiki.detail.evidenceBased": "根據審核證據修正",
  "wiki.detail.viewCorrected": "查看 AI 修正後的完整內容",
  "wiki.detail.acceptCorrections": "接受修正並重新審核",
  "wiki.detail.manualReview": "不確認，轉人工複核",
  "wiki.detail.saveAndReview": "儲存並提交審核",
  "wiki.detail.saveDraft": "儲存草稿",
  "wiki.detail.save": "儲存",
  "wiki.detail.resubmitReview": "儲存並重新提交審核",
  "wiki.detail.saveAndPublish": "儲存併發布",
  "wiki.detail.loginToEdit": "請先登入，登入後才能修改百科詞條",
  "wiki.detail.draftUnavailable": "暫未生成可編輯的百科草稿，請稍後重試",
  "wiki.detail.draftLoadFailed": "載入百科草稿失敗，請稍後重試",
  "wiki.detail.loginToPublish": "請先登入，登入後才能修改或發佈百科詞條",
  "wiki.detail.requiredFields": "請填寫詞條名稱、詞條釋義和百科正文",
  "wiki.detail.revisionSubmitted":
    "修改已提交審核，審核通過併發布後將計入編輯次數",
  "wiki.detail.submitFailed": "修改提交失敗",
  "wiki.detail.largeFile": "儲存失敗，上傳檔案可能過大，請刪除或壓縮後再儲存",
  "wiki.detail.saveFailed": "儲存修改失敗",
  "wiki.detail.revisionSaved": "修改已提交，已記錄為新的詞條版本",
  "wiki.detail.draftNotFound": "未找到可儲存的百科草稿",
  "wiki.detail.draftSaveFailed": "儲存百科草稿失敗",
  "wiki.detail.correctionsConfirmed": "AI 修正已確認，修正版已重新提交審核",
  "wiki.detail.correctionsFailed": "確認 AI 修正失敗",
  "wiki.detail.sentToHuman": "已轉入人工複核，請在“我的發佈”查看進度",
  "wiki.detail.humanReviewFailed": "轉人工複核失敗",
  "wiki.detail.loginToRelease": "請先登入，登入後才能發佈百科詞條",
  "wiki.detail.releaseFailed": "發佈百科內容失敗",
  "wiki.detail.draftSaved": "百科草稿已儲存到數據庫",
  "wiki.detail.needsRevision": "審核認為內容需要修改，請完善後重新提交",
  "wiki.detail.highRisk": "內容存在高風險或不確定項，已轉人工複核",
  "wiki.detail.reviewSubmitted": "百科內容已提交智能審核",
  "wiki.detail.scheduled": "智能審核通過，已進入計劃發佈",
  "wiki.detail.rewarded": "百科內容審核通過併發布，+{points} 積分",
  "wiki.detail.rewardLimit":
    "百科內容審核通過併發布；今日獎勵已達 {limit} 積分上限",
  "wiki.detail.published": "百科內容已發佈",
  "wiki.detail.reviewStatus": "內容已提交審核，審核結果可在“我的”中進行查看",
  "wiki.detail.reviewRewarded":
    "百科內容審核通過，+{points} 積分，點擊查看明細",
  "wiki.detail.reviewRewardLimit":
    "百科內容審核通過；今日獎勵已達 {limit} 積分上限",
  "wiki.detail.assistantTitle": "百科 AI 助手",
  "wiki.detail.assistantSubtitle": "自動檢索百科與規格書",
  "wiki.detail.collapseAssistant": "收回",
  "wiki.detail.viewConversation": "查看對話",
  "wiki.detail.me": "我",
  "wiki.detail.sourceCatalog": "來自產品庫中的實際型號",
  "wiki.detail.sourceClarify": "需要補充提問資料",
  "wiki.detail.sourceModel": "基於模型通用知識，非規格書原文依據",
  "wiki.detail.sourceAll": "本次已自動檢索全部知識庫規格書",
  "wiki.detail.sourceCurrent": "本次已自動檢索當前詞條規格書",
  "wiki.detail.datasheet": "規格書",
  "wiki.detail.page": "第 {page} 頁",
  "wiki.detail.parameterRecord": "參數記錄",
  "wiki.detail.tryAsking": "試試這樣問",
  "wiki.detail.voltageQuestion": "這個產品的工作電壓是多少？",
  "wiki.detail.packageQuestion": "這個產品採用什麼封裝形式？",
  "wiki.detail.compareQuestion": "對比這個產品和同類型號的工作電壓與封裝。",
  "wiki.detail.searchQuestion": "知識庫中有哪些支持 3V 供電的產品？",
  "wiki.detail.voltage": "工作電壓",
  "wiki.detail.package": "封裝形式",
  "wiki.detail.compare": "同類對比",
  "wiki.detail.searchAll": "全庫查找",
  "wiki.detail.assistantLongWait":
    "本次處理時間較長，請稍候。你也可以隨時暫停。",
  "wiki.detail.assistantWorking": "會結合對話內容，並按問題需要檢索資料。",
  "wiki.detail.seconds": "{count} 秒",
  "wiki.detail.questionPlaceholder": "輸入百科問題、型號、品牌或對比需求…",
  "wiki.detail.pauseAnswer": "暫停本次回答",
  "wiki.detail.pause": "暫停",
  "wiki.detail.send": "發送",
  "wiki.detail.sourceHint": "自動選擇檢索範圍，回答附原文依據",
  "wiki.detail.shortcut": "Ctrl + Enter 發送",
  "wiki.detail.schedulePrompt": "請輸入發佈時間（例如 2026-08-03 18:30:00）",
  "wiki.detail.scheduleTitle": "計劃發佈百科正文",
  "wiki.detail.scheduleFormat":
    "請輸入 YYYY-MM-DD HH:mm 或 YYYY-MM-DD HH:mm:ss",
  "wiki.detail.scheduleFuture": "發佈時間必須晚於當前時間",
  "wiki.detail.scheduleSaved": "已儲存計劃，到設定時間將自動發佈正文",
  "wiki.detail.scheduleFailed": "計劃發佈百科內容失敗",
});

export const messages = Object.freeze({ ...personal, ...display, ...pages });
